// NativeVideoPlayer.js
'use strict';
import { connect } from 'react-redux';

import NativeVideoPlayer from '../component/NativeVideoPlayer.jsx';

export default connect(null, null)(NativeVideoPlayer);
